import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { first, map } from 'rxjs';
import { Permission } from '@core/permissions/models/permission.enum';
import { NavigationFacade } from '@core/navigation/facades/navigation.facade';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';

export const hasPermissionGuard =
  (permission: Permission | Permission[], requireAllPermissions?: boolean): CanMatchFn =>
  ({ path }) => {
    const router = inject(Router);
    const permissionsFacade = inject(PermissionsFacade);
    const navigationFacade = inject(NavigationFacade);

    return permissionsFacade.permissionsLoaded$.pipe(
      first(),
      map(() => {
        if (permissionsFacade.hasPermission(permission, requireAllPermissions)()) {
          return true;
        }

        if (navigationFacade.redirectLeftNavigation() === path && navigationFacade.nextRedirectLeftNavigation()) {
          return navigationFacade.redirectToNextLeftNavigation();
        }

        return router.createUrlTree(['access-denied']);
      })
    );
  };
